var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_wrapper"},[_c('left-menu',{attrs:{"title":"风资源参数分析","module-type":"analysis"}}),_c('main-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }